import { Pipe, PipeTransform, inject } from '@angular/core';
import { LocaleService } from './locale.service';

@Pipe({
  name: 'localizedRouterLink',
  standalone: true,
  pure: false,
})
export class LocalizedRouterLinkPipe implements PipeTransform {
  private readonly localeService = inject(LocaleService);

  transform(path: string | null | undefined): string | null | undefined {
    return path ? this.localeService.localizedPath(path) : path;
  }
}
